// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/settings.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-profile {
  justify-content: flex-start;
  flex-direction: row;
  align-content: flex-start;
  align-items: stretch;
}
.sidebar-profile .texts {
  font-size: 12px;
  height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 160px;
}

.sidebar-profile-box {
  border-radius: 12px;
  width: 78% !important;
  margin: 10px;
  padding: 15px;
  height: fit-content !important;
}

.sidebar-profile-box.sidenav---expanded---1KdUL {
  width: 92% !important;
}

.sidebar-profile-box .free-badge {
  background-color: #3FDD78;
  width: inherit;
  height: 24px;
  padding: 5px 10px !important;
  color: #232627;
  border-radius: 8px;
  font-size: 12px !important;
}

.sidebar-profile-box .free-badge-7 {
  background-color: #3FDD78;
  height: 24px;
  color: #232627;
  border-radius: 8px;
  font-size: 12px !important;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 48px;
}

.profile-item-sidebar {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.profile-item-sidebar div {
  display: flex;
  column-gap: 10px;
}

.profile-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  min-height: 50px;
}

.profile-container .texts {
  font-size: 14px;
  margin-bottom: 5px;
}

.profile-container-info {
  display: flex;
  flex-direction: column;
  font-weight: 400;
}

.profile-user-name {
  display: flex;
  gap: 10px;
}

.profile-user-name span {
  font-weight: 500;
  color: #fff;
}

.sidebar-upgrade button {
  border: solid 2px #343839 !important;
  background-color: transparent !important;
  border-radius: 12px;
  padding: 10px 50px;
  width: 100%;
  margin-top: 20px;
  font-weight: 600;
}

.logout-button {
  padding: 0 !important;
}

.logout-button .sidenav---navtext---1AE_f {
  padding-top: 2px !important;
  text-align: center !important;
  width: 60% !important;
}

.logout-button div {
  padding: 0 !important;
  margin-left: -2px;
  color: #D84C10 !important;
}

html body .sidenav---sidenav-nav---3tvij > .logout-button:hover {
  background-color: transparent !important;
  opacity: 1 !important;
}

.settings-mini {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  border: none;
  width: 40px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/Components/SidebarProfile/sidebarprofile.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAGA;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAAF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;AADF;;AAIA;EACE,aAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,oCAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,2BAAA;EACA,6BAAA;EACA,qBAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;EACA,yBAAA;AADF;;AAIA;EACE,wCAAA;EACA,qBAAA;AADF;;AAMA;EACE,oEAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAHF","sourcesContent":[".sidebar-profile {\n  justify-content: flex-start;\n  flex-direction: row;\n  align-content: flex-start;\n  align-items: stretch;\n\n  .texts {\n    font-size: 12px;\n    height: 18px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 160px;\n  }\n}\n\n.sidebar-profile-box {\n  border-radius: 12px;\n  width: 78% !important;\n  margin: 10px;\n  padding: 15px;\n  height: fit-content !important;\n}\n\n.sidebar-profile-box.sidenav---expanded---1KdUL {\n  width: 92% !important;\n}\n\n.sidebar-profile-box .free-badge {\n  background-color: #3FDD78;\n  width: inherit;\n  height: 24px;\n  padding: 5px 10px !important;\n  color: #232627;\n  border-radius: 8px;\n  font-size: 12px !important;\n}\n\n.sidebar-profile-box .free-badge-7 {\n  background-color: #3FDD78;\n  height: 24px;\n  color: #232627;\n  border-radius: 8px;\n  font-size: 12px !important;\n  width: fit-content;\n  padding-left: 10px;\n  padding-right: 10px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-left: 48px;\n}\n\n\n.profile-item-sidebar {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.profile-item-sidebar div {\n  display: flex;\n  column-gap: 10px;\n}\n\n.profile-container {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  min-height: 50px;\n}\n\n.profile-container .texts {\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n\n.profile-container-info {\n  display: flex;\n  flex-direction: column;\n  font-weight: 400;\n}\n\n.profile-user-name {\n  display: flex;\n  gap: 10px;\n}\n\n.profile-user-name span {\n  font-weight: 500;\n  color: #fff;\n}\n\n.sidebar-upgrade button {\n  border: solid 2px #343839 !important;\n  background-color: transparent !important;\n  border-radius: 12px;\n  padding: 10px 50px;\n  width: 100%;\n  margin-top: 20px;\n  font-weight: 600;\n}\n\n.logout-button {\n  padding: 0 !important;\n}\n\n.logout-button .sidenav---navtext---1AE_f {\n  padding-top: 2px !important;\n  text-align: center !important;\n  width: 60% !important;\n}\n\n.logout-button div {\n  padding: 0 !important;\n  margin-left: -2px;\n  color: #D84C10 !important;\n}\n\nhtml body .sidenav---sidenav-nav---3tvij>.logout-button:hover {\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n\n.current-plan-info {}\n\n.settings-mini {\n  background: url(../../Assets/Images/settings.svg) no-repeat center;\n  border: none;\n  width: 40px;\n  height: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
